export default __webpack_public_path__ + "static/media/body_organ_blood.3cce5724.png";